export const TAG_STATUS_SUCCESS = 'success';
export const TAG_STATUS_PROCESSING = 'processing';
export const TAG_STATUS_ERROR = 'error';
export const TAG_STATUS_WARNING = 'warning';
export const TAG_STATUS_DEFAULT = 'default';
